
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-node-demo-node-shapes","docs-tutorial-basic-node-demo-node-registry","docs-tutorial-basic-node-demo-node-prop"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.en.md?type=demo')
};